var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// lib/helpers/boot/index.ts
var scriptSrc = "https://chat-assets.frontapp.com/v1/chat.bundle.js";
async function boot(element, options) {
  const scriptTag = document.createElement("script");
  scriptTag.setAttribute("type", "text/javascript");
  scriptTag.setAttribute("src", scriptSrc);
  if (options?.nonce) {
    scriptTag.setAttribute("nonce", options.nonce);
  }
  const scriptContainer = element ?? document.body;
  const loadScriptPromise = new Promise((resolve) => {
    scriptTag.onload = () => {
      if (!window.FrontChat) {
        throw new Error("[front-chat-sdk] Could not set up window.FrontChat");
      }
      resolve(window.FrontChat);
    };
  });
  scriptContainer.appendChild(scriptTag);
  return loadScriptPromise;
}

export { __export, boot };
//# sourceMappingURL=chunk-YAU6GWLC.js.map
//# sourceMappingURL=chunk-YAU6GWLC.js.map